import { render, staticRenderFns } from "./AuditStatistic.vue?vue&type=template&id=5054f56e&"
import script from "./AuditStatistic.vue?vue&type=script&lang=js&"
export * from "./AuditStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports